<template>
  <div class="answer-wrapper">
    <!-- 如果有子题目，统一显示子题目的答案和解析 -->
    <template v-if="test.subtests && test.subtests.length">
      <div class="answer">
        <div>💡正确答案：</div>
        <div class="subtest-answers">
          <span v-for="(subtest, index) in test.subtests" :key="subtest.id" class="subtest-answer-item">
            ({{ index + 1 }}){{ subtest.answer || '暂无答案' }}
          </span>
        </div>
      </div>
      <div class="explain">
        <div>🔗参考解析：</div>
        <div class="subtest-explains">
          <template v-if="hasAnySubtestExplain">
            <div v-for="(subtest, index) in test.subtests" :key="subtest.id" class="subtest-explain-item" v-html="formatExplain(subtest.explain, index + 1)">
            </div>
          </template>
          <template v-else>
            <div v-html="convertTestText(test.explain || '暂无解析')"></div>
          </template>
        </div>
      </div>
    </template>
    <!-- 没有子题目，显示主题目答案解析 -->
    <template v-else>
      <div class="answer">
        <div>💡正确答案：</div>
        <div>{{ test.answer || '暂无答案' }}</div>
      </div>
      <div class="explain">
        <div>🔗参考解析：</div>
        <div v-html="convertTestText(test.explain || '暂无解析')"></div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'answer',
  props: {
    test: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
    }
  },
  computed: {
    hasAnySubtestExplain() {
      if (!this.test.subtests || !this.test.subtests.length) {
        return false;
      }
      return this.test.subtests.some(subtest => subtest.explain && subtest.explain.trim());
    }
  },
  methods: {
    formatExplain(explain, index) {
      const text = explain || '';
      const formattedText = `(${index})${text}`;
      return this.convertTestText(formattedText);
    }
  }
}
</script>

<style scoped>
.answer-wrapper {
  width: 100%;
  margin-top: 20px;
  border-radius: 8px;
}

.answer {
  margin-bottom: 12px;
  line-height: 28px;
  font-size: 20px;
}

.subtest-answers {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 5px;
}

.subtest-explains {
  margin-top: 5px;
}

.subtest-answer-item {
  margin-right: 15px;
}

.subtest-explain-item {
  margin-bottom: 10px;
  line-height: 28px;
}

.explain {
  line-height: 28px;
  font-size: 20px;
}

/* 优化音频播放器样式 */
.answer-wrapper audio {
  width: 100%;
  max-width: 400px;
  height: 40px;
  display: inline-block;
  vertical-align: middle;
  margin: 5px 0;
}

/* 优化图片显示 */
.answer-wrapper img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 10px 0;
  border-radius: 4px;
}
</style>
